<template>
  <div class="overflow-hidden position-relative item">
    <img
      class="d-block item-img"
      src="../../assets/img/banner-top.webp"
      width="100%"
      :height="xs ? '250px' : '400px'"
    />

    <div class="animation waves">
      <AnimationWidget animation="waves" />
    </div>
  </div>
</template>

<script>
import AnimationWidget from "../widgets/AnimationWidget.vue";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  components: {
    AnimationWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    object-fit: cover;
    -o-object-fit: cover;
  }
}

.animation {
  bottom: 0;
  pointer-events: none;
  position: absolute;

  &.waves {
    bottom: -30px;
    width: 110%;

    @media screen and (max-width: 960px) {
      bottom: -20px;
    }
  }
}
</style>
